import React from 'react';

function Footer(props) {
  return (
    <div>
      <hr />
      <span>copyright: yc.about@gmail.com | 2019 | Canada</span>
    </div>
  );
}
export default Footer;